module.exports = __webpack_public_path__ + "img/20190528162057296.95ed2633.png";